var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"messages"},_vm._l((_vm.messages),function(item){return _c('b-alert',{key:item.message,attrs:{"show":"","dismissible":"","variant":item.variant}},[_vm._v(_vm._s(item.message))])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21a0ba8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/default/messages.vue
// module id = Hy2l
// module chunks = 32